














































































import settings from '@/settings'
import Menus from '@/components/menus'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import d from '@/utils/imports'

export default {
    name: 'imports'

    components: { Menus }

    props:
        item:
            type: String

    data: ()->
        item_set: []
        item_fields: []
        selected_item: ''

    computed:
        company_uid: ()->
            # console.log "GETTERS IMPORT", @$store.state.selected_company.uid
            return @$store.state.selected_company.uid

    methods:
        download_example: (name)->
            self = @
            @$http({
                method: 'get',
                url: settings.frontend_url+"/assets/csv/exemple_"+name+".csv",
                responseType: 'arraybuffer'
            })
            .then (resp)->
                url = window.URL.createObjectURL(new Blob([resp.data]))
                link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'exemple_'+name+'.csv')
                link.click()

        define_item_set: ()->
            # console.log "DEFINE ITEM SET ", @item
            set = []
            @item_fields = []
            if t.has_access_right(d['companies']['access_set'][0])
                set.push({'id':'companies','label':d['companies']['label']})
            if @company_uid != ''
                if t.has_access_right(d['establishments']['access_set'][0])
                    set.push({'id':'establishments','label':d['establishments']['label']})
                if t.has_access_right(d['users']['access_set'][0])
                    set.push({'id':'users','label':d['users']['label']})
                if t.has_access_right(d['user_salaries']['access_set'][0])
                    set.push({'id':'user_salaries','label':d['user_salaries']['label']})
                if t.has_access_right(d['users_jobs']['access_set'][0])
                    set.push({'id':'users_jobs','label':d['users_jobs']['label']})
                if t.has_access_right(d['balances']['access_set'][0])
                    set.push({'id':'balances','label':d['balances']['label']})
            @item_set = set
            if @item not in [undefined, null]
                # console.log "ITEM DEFINED"
                for s in set
                    if s.id == @item
                        @selected_item = @item
                        for f of d[s['id']]['fields']
                            @item_fields.push(d[s['id']]['fields'][f])
                        return
            else
                # console.log "ITEM UNDEFINED"
                @selected_item = set[0]['id']
                for f of d[@selected_item]['fields']
                    @item_fields.push(d[@selected_item]['fields'][f])
                return

            n.access_error("Vous n'avez pas les droits nécessaires")
            @$router.push({name:"dashboard"})
            return

        change_selected_item: ()->
            # console.log "CHANGE SELECTED ITEM", @selected_item
            @item_fields = []
            for f of d[@selected_item]['fields']
                @item_fields.push(d[@selected_item]['fields'][f])
            return

        next_step: (uid)->
            @$router.push({name:"imports_upload", params:{uid:uid, item:@selected_item}})
            return
            
    beforeMount: ()->
        # console.log "IMPORT BEFORE MOUNT", @item
        @define_item_set()
}
